import { render, staticRenderFns } from "./Nice404.vue?vue&type=template&id=356856fe&scoped=true"
import script from "./Nice404.vue?vue&type=script&lang=js"
export * from "./Nice404.vue?vue&type=script&lang=js"
import style0 from "./Nice404.vue?vue&type=style&index=0&id=356856fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356856fe",
  null
  
)

export default component.exports